/**
 * author:Bry
 * Data:2023-04-17 13:55
 * des:故障管理js
 */


import config from "@/config";
import http from "@/utils/request";

export default {
	page: {
		url: `${config.MAIN_URL}/maintenance/breakdownManage/brokenRecordList`,
		name: "故障记录分页查询",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getDeptList: {
		url: `${config.MAIN_URL}/api/v1/hw/boardingCheckList/getDeptList`,
		name: "航务-飞行大队下拉",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getAircraft: {
		url: `${config.MAIN_URL}/api/v1/company/model/getAircraft`,
		name: "航务-飞行大队下拉",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	modelnum: {
		url: `${config.MAIN_URL}/api/v1/company/model/num`,
		name: "航务-飞行大队下拉",
		get: async function (params) {
			return await http.get(this.url+ params);
		},
	},
	getInstructorListCascadeDeptId: {
		url: `${config.MAIN_URL}/api/v1/hw/boardingCheckList/getInstructorListCascadeDeptId`,
		name: "航务登机检查单-教员级联飞行大队下拉",
		get: async function (params) {
			return await http.get(this.url+ params);
		},
	},
	getUserListByRole: {
		url: `${config.MAIN_URL}/api/v1/hw/boardingCheckList/getUserListByRole`,
		name: "航务登机检查单-人员下拉",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getAircraftNo: {
		url: `${config.MAIN_URL}/maintenance/breakdownManage/getAircraftNo`,
		name: "机号下拉列表",
		get: async function () {
			return await http.get(this.url);
		},
	},
	assessorSign: {
		url: `${config.MAIN_URL}/api/v1/hw/boardingCheckList/assessorSign`,
		name: "审批",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	assessorSignpost: {
		url: `${config.MAIN_URL}/api/v1/hw/boardingCheckList/assessorSign`,
		name: "审批",
		post: async function (params) {
			return await http.post(this.url,params);
		},
	},
	assessorSignpostAll: {
		url: `${config.MAIN_URL}/api/v1/hw/boardingCheckList/assessorBatchSign`,
		name: "批量审批",
		post: async function (params) {
			return await http.post(this.url,params);
		},
	},


	/* getFileInfo: {
		url: `${config.MAIN_URL}/maintenance/breakdownManage/getFileInfo`,
		name: "文件上传数据回显-合同",
		get: async function (params) {
			return await http.get(this.url + params);
		},
	}, */


	addbrokenRecord: {
		url: `${config.MAIN_URL}/maintenance/breakdownManage/addbrokenRecord`,
		name: '新增故障记录',
		post: async function (data) {
			return await http.post(this.url, data);
		},
	},
	updatebrokenRecord: {
		url: `${config.MAIN_URL}/maintenance/breakdownManage/updatebrokenRecord`,
		name: "编辑故障记录",
		put: async function (data) {
			return await http.put(this.url, data);
		},
	},
	/* updateContractRate: {
		url: `${config.MAIN_URL}/maintenance/breakdownManage/updateContractRate`,
		name: "编辑合同执行进度",
		put: async function (data) {
			return await http.put(this.url, data);
		},
	}, */
	deletebrokenRecord: {
		url: `${config.MAIN_URL}/maintenance/breakdownManage/deletebrokenRecord`,
		name: "删除故障记录",
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},

};
